<template>
  <section
    class="avaluos-bank-criteria"
    aria-labelledby="avaluos-bank-criteria-title"
  >
    <h2
      id="avaluos-bank-criteria-title"
      class="avaluos-bank-criteria__title"
    >
      Criterios si lo realizas con una institución bancaria
    </h2>

    <div class="avaluos-bank-criteria__content">
      <DsText as="body3" class="avaluos-bank-criteria__description">
        Tienes la posibilidad de realizar tu avalúo con cualquier institución
        bancaria, siempre y cuando cumpla con los siguientes criterios:
      </DsText>

      <ul class="avaluos-bank-criteria__items">
        <li
          v-for="criterion in criteria"
          :key="criterion.id"
          class="avaluos-bank-criteria__item"
        >
          <span
            class="avaluos-bank-criteria__icon-box"
            aria-hidden="true"
          >
            <img
              class="avaluos-bank-criteria__icon"
              :src="checkIcon"
              alt=""
            >
          </span>

          <DsText as="body3" class="avaluos-bank-criteria__item-text">
            {{ criterion.text }}
          </DsText>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import checkIcon from '../../../../../assets/avaluos/avaluos-check.svg'
import DsText from '../atoms/DsText.vue'

const criteria = [
  {
    id: 'bank-document',
    text:
      'Expedido por un banco en hoja membretada y con sello de la ' +
      'institución.'
  },
  {
    id: 'credit-purpose',
    text: 'Que el propósito del documento sea para Originación de crédito.'
  }
]
</script>

<style scoped>
.avaluos-bank-criteria,
.avaluos-bank-criteria__content,
.avaluos-bank-criteria__items {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.avaluos-bank-criteria {
  gap: 24px;
}

.avaluos-bank-criteria__title {
  width: 100%;
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: var(--ds-bebas4-size);
  font-weight: var(--ds-bebas4-weight);
  line-height: normal;
}

.avaluos-bank-criteria__content {
  gap: 16px;
}

.avaluos-bank-criteria__description,
.avaluos-bank-criteria__item-text {
  color: var(--ds-text-primary);
  line-height: 24px;
}

.avaluos-bank-criteria__items {
  gap: 24px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.avaluos-bank-criteria__item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.avaluos-bank-criteria__icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
}

.avaluos-bank-criteria__icon {
  display: block;
  width: 21px;
  height: 16px;
}

.avaluos-bank-criteria__item-text {
  min-width: 0;
}
</style>
